import { render } from "./g-splitter.vue?vue&type=template&id=a9c81836&ts=true"
import script from "./g-splitter.vue?vue&type=script&lang=tsx"
export * from "./g-splitter.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__